var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2 offset-md-4 text-right center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-fill",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  return _vm.edit()
                }
              }
            },
            [_vm._v("Edit Plan")]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.plan,
              expression: "plan"
            }
          ],
          staticClass: "table-responsive"
        },
        [
          _c("table", { staticClass: "table table-bordered table-light" }, [
            _c("tr", [
              _c("th", [_vm._v("Id")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.plan.packageId))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("name")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.plan.name))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("Amount")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.plan.amount))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("Type")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.plan.type))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("description")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.plan.description))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("Start Date")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.plan.startDate))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("End Date")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.plan.endDate))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("Status")]),
              _vm._v(" "),
              _c("td", [
                _vm.plan.active
                  ? _c("span", { staticClass: "badge badge-success" }, [
                      _vm._v(" Active ")
                    ])
                  : _c("span", { staticClass: "badge badge-danger" }, [
                      _vm._v(" Inactive ")
                    ])
              ])
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Plan Details")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1550fb10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1550fb10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Plans/PlanDetails.vue
// module id = 5JEE
// module chunks = 0